export const getAssetPath = (path) => {
    let baseUrl = "/";
    if (document.currentScript) {
        let _documentUrl = document.currentScript.src.split("/");
        baseUrl = _documentUrl[0] + "//" + _documentUrl[2] + "/";
    }
    return baseUrl.concat(path);
};



// WEBPACK FOOTER //
// ./src/components/V2/utils.js